// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"9":"1fff733e","452":"1fff733e"}[chunkId] + ".chunk.css";
};